import { render } from "./VisitsForCaller.vue?vue&type=template&id=066055e0&scoped=true"
import script from "./VisitsForCaller.vue?vue&type=script&lang=js"
export * from "./VisitsForCaller.vue?vue&type=script&lang=js"

import "./VisitsForCaller.vue?vue&type=style&index=0&id=066055e0&scoped=true&lang=css"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-view\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-066055e0"]])

export default __exports__